<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    深大站<br>
站点介绍<br>
本站处于深南大道与科苑南路交界处，是南山区的主要交通干道，西北侧是深圳大学，东侧为高新科技园。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:03	23:32	1号线	2分钟	4分40秒<br>
机场东	06:02	23:36	1号线	2分钟	4分40秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:22	23:31	1号线	3分45秒	5分45秒<br>
机场东	06:26	23:36	1号线	3分45秒	5分45秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:22	00:31	1号线	3分45秒	5分45秒<br>
机场东	06:26	00:36	1号线	3分45秒	5分45秒<br><br>
<br>
站点出口信息<br><br>
A1出入口:<br>
（暂未开通）<br><br>
A2出入口:<br>
深圳深铁皇冠假日酒店<br><br>
A3出入口:<br>
深南大道北侧（西）、南山蛇口宝安方向、科技中三路、科技园文化广场、深圳软件园 (西区）<br><br>
A4出入口:
深南大道北侧（东）、科苑南路<br><br>
C出入口:<br>
科技南一路、深圳虚拟大学园、粤海门村、深圳软件园、数字软件园、深圳大学、深圳市人才交流中心、深港产学研基地、深圳清华大学研究院、香港理工大学产学研基地<br><br>
D出入口:<br>
科苑南路、科技南一路、深圳深铁皇冠假日酒店 、深铁金融科技大厦、科技园公交首末站<br><br>
公交换乘信息<br><br>
A2、A3出入口:<br>
公交站名： 科技园①<br>
320、323、324、328、338、K578(右环)、M191、M194、M222、M358、M372、M413、M433、M435、M448、M530、M554<br><br>
A2、A3出入口:<br>
公交站名： 科技园②<br>
101、113、19、204、21、223、234、N4、369、42、70、79、81、M200、M398、M453、N8<br><br>
A2、A3出入口:<br>
公交站名： 深大北门①<br>
324、338、395、M200、M372、M222、M413、M425、M435、M194<br><br>
A4出入口:<br>
公交站名： 深南科苑立交北<br>
325、339、49、81、B683、E9、M109、M200、M209、M299、M313、M429、M453、M528<br><br>
C出入口:<br>
公交站名： 高科技中心<br>
325、339、49、B607、B683、E19、E39、E9、M183、M209、M299、M313、M345、M429、M528、M554<br><br>
C出入口:<br>
公交站名： 深大地铁站<br>
36、45、49、339、B607、B683、B728、M109、M183、M313<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>

